import { createSelector } from 'reselect'
import { modes } from '@/components/changeRequests/propertyRenderer'
import context from '@/context'

export const activeTaskSelector = state => !context.isReportApp() ? state.myActiveTask.activeTask : null
export const formPropsSelector = (state, props) => {
  let { uid, parentUid, scope, id, isChangeItemId, target, isTempForm, mode } = props
  if (!scope && parentUid) {
    const parent = state.forms.getIn(['data', parentUid])
    if (parent) {
      scope = parent.get('scope')
      id = parent.get('id')
    }
  }
  const data = state.forms.getIn(['data', uid])
  const isLoaded = !!data
  const changeItemId = (isChangeItemId ? id : null) || props.changeItemId
  const unavailable = !!data && !data.get('modifiedData')
  const targetId = data && data.get('targetId') ? Number(data.get('targetId')) : null
  const targetInstitutionId = data && data.get('originalData') && data.get('originalData').get('institutionId')
  const changeRequestId = (data && data.get('changeRequestId')) || null
  const isActiveChangeRequest = (data && data.get('isActiveChangeRequest')) || false
  if (!context.isReportApp()) {
    const task = activeTaskSelector(state)
    mode = getMode(scope, isChangeItemId && task &&
      changeRequestId === task.changeRequestId &&
      // task.changeRequest && task.changeRequest.items && task.changeRequest.items.find(i => i.id === changeItemId) &&
      task.type && task.type.permissions)
  } else {
    mode = isActiveChangeRequest ? modes.edit : modes.view // if => changeItem.changeRequestId === currentChangeRequest
  }
  return {
    uid,
    parentUid,
    scope,
    id,
    target,
    data,
    isChangeItemId,
    changeItemId,
    changeRequestId,
    isLoaded,
    unavailable,
    targetId,
    targetInstitutionId,
    isTempForm,
    mode
  }
}

function getMode (scope, permissions) {
  if (permissions) {
    if (permissions.indexOf(`Scopes.${scope}.Edit`) >= 0) return modes.edit
    if (permissions.indexOf(`Scopes.${scope}.Approve`) >= 0) return modes.approval
  }
  return modes.view
}

export const formDataSelector = (state, props) => state.forms.getIn(['data', props.parentUid || props.uid])
export const changeRequestIdSelector = !context.isReportApp()
  ? createSelector(activeTaskSelector, task => (task && task.changeRequestId) || null)
  : state => state.changeRequest && state.changeRequest.id

const approvalInfoSelector = createSelector(formDataSelector, data => data && data.get('approvalInfo'))
export const approvedCountSelector = createSelector(approvalInfoSelector, approved => approved && approved.filter(v => v === true).size)
export const rejectedCountSelector = createSelector(approvalInfoSelector, approved => approved && approved.filter(v => v === false).size)
export const pendingCountSelector = createSelector(approvalInfoSelector, approved => approved && approved.filter(v => typeof v !== 'boolean').size)
export const approvalSummarySelector = createSelector(approvedCountSelector, rejectedCountSelector, pendingCountSelector,
  (approved, rejected, pending) => ({ approved, rejected, pending }))



// WEBPACK FOOTER //
// ./src/components/changeRequests/selectors.js